import {
  RECORD_REQUEST_SET_PROVIDER,
  RECORD_REQUEST_SET_PATIENT,
  RECORD_REQUEST_SET_DATE,
  RECORD_REQUEST_SET_AUTHORIZATION,
  RECORD_REQUEST_SET_PAYMENT,
  RECORD_REQUEST_RESET,
  RECORD_REQUEST_LOADING,
  RECORD_REQUEST_SET_CARD_NUMBER,
  RECORD_REQUEST_SET_CARD_TYPE,
  RECORD_REQUEST_SET_PROVIDER_NAME,
  RECORD_REQUEST_SET_REQUEST_ID,
  RECORD_REQUEST_FAILURE,
  RECORD_REQUEST_PATIENT_INFO,
  RECORD_REQUEST_SET_AUTH_TYPE,
  RECORD_REQUEST_SET_ESTIMATE_AUTH,
  RECORD_REQUEST_SET_PAYMENT_METHOD,
  RECORD_REQUEST_SET_REQUEST_DETAILS,
  RECORD_REQUEST_SET_SHOW_PROMPT,
  RECORD_REQUEST_SET_RID,
  RECORD_REQUEST_SET_GOVT_ID,
  RECORD_REQUEST_SET_SUPPORTING_DOCS,
  RECORD_REQUEST_DELETE_SUPPORTING_DOC,
} from 'store/types/recordRequest.type';

import { State } from 'store/reducers/recordRequest.reducer';
import { AuthFormValues, RecordDate, RequestDetail, GovtId, SupportingDocs } from 'types/requestItem';
import { ThunkAction } from 'redux-thunk';
import { api2 } from '../apis';
import { commonError, commonLoading, commonSuccess } from './common.action';
import { notifyCustomerSurveyRequestActivity } from 'components/modals/CustomerSurvey/customerSurveyEvents';

export const setEstimateAuth = (estimateInitials: string) => ({
  type: RECORD_REQUEST_SET_ESTIMATE_AUTH,
  estimateInitials,
});

export const setRecordRequestProvider = (provider: any) => ({
  type: RECORD_REQUEST_SET_PROVIDER,
  provider,
});

export const setRecordRequestPatientId = (id: string) => ({
  type: RECORD_REQUEST_SET_PATIENT,
  id,
});

export const setRecordRequestFailure = (error: string) => ({
  type: RECORD_REQUEST_FAILURE,
  error,
});

export const setRecordRequestDate = (date: RecordDate) => ({
  type: RECORD_REQUEST_SET_DATE,
  date,
});

export const setRecordRequestAuthorization = (token: AuthFormValues) => ({
  type: RECORD_REQUEST_SET_AUTHORIZATION,
  token,
});

export const setRecordRequestGovtId = (data: GovtId, required = true) => ({
  type: RECORD_REQUEST_SET_GOVT_ID,
  data,
  required,
});

export const getGovtId = (rid: number): ThunkResult<void> => async dispatch => {
  return api2
    .get(`/api/v2/authorizations/government_id?rid=${rid}`)(dispatch)
    .then(res => {
      if (res) {
        const { front_file, back_file } = res;

        dispatch(
          setRecordRequestGovtId({
            frontFileId: front_file?.id,
            frontFileURL: front_file?.url,
            frontFileName: front_file?.name,
            backFileId: back_file?.id,
            backFileURL: back_file?.url,
            backFileName: back_file?.name,
          }),
        );
      }
    })
    .catch(error => console.error('error', error));
};

export const removeGovtIdDocument = (
  document_id: number,
  type: 'front_file' | 'back_file',
): ThunkResult<void> => async dispatch => {
  api2
    .delete(`/api/v2/authorizations/remove_government_id?document_id=${document_id}`)(dispatch)
    .then(res => {
      if (type === 'front_file') {
        dispatch(
          setRecordRequestGovtId({
            frontFileId: undefined,
            frontFile: undefined,
            frontFileURL: undefined,
            frontFileName: undefined,
          }),
        );
      }
      if (type === 'back_file') {
        dispatch(
          setRecordRequestGovtId({
            backFileId: undefined,
            backFile: undefined,
            backFileURL: undefined,
            backFileName: undefined,
          }),
        );
      }
    });
};

export const setRecordRequestSupportingDocs = (docs: SupportingDocs[]) => ({
  type: RECORD_REQUEST_SET_SUPPORTING_DOCS,
  docs,
});

export const setRecordRequestPaymentMethod = (value: string) => ({
  type: RECORD_REQUEST_SET_PAYMENT_METHOD,
  value,
});

export const setRecordRequestPayment = (id: string) => ({
  type: RECORD_REQUEST_SET_PAYMENT,
  id,
});

export const setRecordRequestReset = () => ({
  type: RECORD_REQUEST_RESET,
});

export const setRecordRequestLoading = (isLoading: boolean) => ({
  type: RECORD_REQUEST_LOADING,
  isLoading,
});

export const setCardNumber = (cardNumber: string) => ({
  type: RECORD_REQUEST_SET_CARD_NUMBER,
  preload: cardNumber,
});

export const setCardType = (cardType: string) => ({
  type: RECORD_REQUEST_SET_CARD_TYPE,
  preload: cardType,
});

export const setProviderName = (name: string) => ({
  type: RECORD_REQUEST_SET_PROVIDER_NAME,
  preload: name,
});

export const setRequestId = (id: string) => ({
  type: RECORD_REQUEST_SET_REQUEST_ID,
  preload: id,
});

export const setPatientInfo = (data: any) => ({
  type: RECORD_REQUEST_PATIENT_INFO,
  preload: data,
});
export const setAuthType = (data: string | undefined | null) => ({
  type: RECORD_REQUEST_SET_AUTH_TYPE,
  preload: data,
});
export const setRequestDetails = (data: RequestDetail, stepChange = true) => ({
  type: RECORD_REQUEST_SET_REQUEST_DETAILS,
  payload: data,
  stepChange,
});
export const setRecordRequestRid = (rid: number) => ({ type: RECORD_REQUEST_SET_RID, rid });
export const setShowPrompt = (flag: boolean, data?: RequestDetail) => ({
  type: RECORD_REQUEST_SET_SHOW_PROMPT,
  flag,
  data,
});
export const deleteRecordSupportingDoc = (fileId: number) => ({ type: RECORD_REQUEST_DELETE_SUPPORTING_DOC, fileId });

export type Actions =
  | ReturnType<typeof setRecordRequestProvider>
  | ReturnType<typeof setCardNumber>
  | ReturnType<typeof setRecordRequestFailure>
  | ReturnType<typeof setRequestId>
  | ReturnType<typeof setProviderName>
  | ReturnType<typeof setCardType>
  | ReturnType<typeof setRecordRequestPatientId>
  | ReturnType<typeof setRecordRequestDate>
  | ReturnType<typeof setRecordRequestAuthorization>
  | ReturnType<typeof setRecordRequestGovtId>
  | ReturnType<typeof setRecordRequestSupportingDocs>
  | ReturnType<typeof deleteRecordSupportingDoc>
  | ReturnType<typeof setRecordRequestPaymentMethod>
  | ReturnType<typeof setRecordRequestPayment>
  | ReturnType<typeof setRecordRequestLoading>
  | ReturnType<typeof setPatientInfo>
  | ReturnType<typeof setAuthType>
  | ReturnType<typeof setEstimateAuth>
  | ReturnType<typeof setRecordRequestReset>
  | ReturnType<typeof setShowPrompt>
  | ReturnType<typeof setRecordRequestRid>
  | ReturnType<typeof setRequestDetails>;

type ThunkResult<R> = ThunkAction<R, State, undefined, Actions>;

export type RecordRequestApiValues = {
  custodian_id: string;
  auth_name: string;
  auth_dob: string;
  auth_ssn: string;
  auth_signature: string;
  auth_signature_id: string;
  auth_print_name: string;
  auth_date: string;
  card_id: string;
  all_records?: boolean;
  records_before?: string;
  records_after?: string;
  dependent_id: string;
};

export const saveRecordRequest = (data: any, callback?: () => void): ThunkResult<void> => async dispatch => {
  dispatch(setShowPrompt(false));
  dispatch(setRecordRequestLoading(true));
  return api2
    .post('/api/v2/request/record_request', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })(dispatch)
    .then(res => {
      dispatch(setRequestId(res.request_rid));
      dispatch(setRecordRequestLoading(false));
      notifyCustomerSurveyRequestActivity({ requestId: res.request_id ?? res.request_rid });
      callback && callback();
    })
    .catch(error => dispatch(setRecordRequestFailure(error.message)));
};

export const draftRecordRequest = (
  data: any,
  callback?: (error: boolean, message: string) => void,
): ThunkResult<void> => async dispatch => {
  if (!callback) dispatch(commonLoading());
  return api2
    .post('/api/v2/request/record_request', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })(dispatch)
    .then(res => {
      if (callback) {
        callback(false, res.message);
        dispatch(setRecordRequestRid(res.request_rid));
      } else dispatch(commonSuccess(res.message));
    })
    .catch(error => {
      if (callback) callback(true, error.message);
      else dispatch(commonError(error.message));
    });
};
export const abandonedRecordRequest = (data: any): ThunkResult<void> => async dispatch => {
  dispatch(setShowPrompt(false));
  dispatch(setRecordRequestReset());
  dispatch(commonLoading());
  return api2
    .post('/api/v2/request/record_request/abandoned_draft_request', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })(dispatch)
    .then(res => dispatch(commonSuccess(res.message)))
    .catch(error => dispatch(commonError(error.message)));
};
export const sendRecordMobileRequest = (params: any): ThunkResult<void> => async dispatch => {
  api2
    .get('/api/v2/authorizations/send_upload_government_document_link', { params })(dispatch)
    .then(res => dispatch(commonSuccess(res.message)))
    .catch(error => dispatch(commonError(error.message)));
};
